import {
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { db } from "../FirebaseConfig";
import { UserAuth } from "../Context";
import { toast } from "react-toastify";
import { toastOptions } from "../lib/toastOptions";
import LoadingSpinner from "../UserProfile/LoadingSpinner";

function CategorySelection() {
  const { user } = UserAuth();
  const [gender, setGender] = useState("male");
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [primaryCategories, setPrimaryCategories] = useState({});
  const [visibleCategories, setVisibleCategories] = useState({
    "Ready to Wear": true,
    "Western Wear": true,
    Unstitched: true,
  });

  // Fetch categories
  const fetchCategories = async () => {
    try {
      setLoading(true);
      const categoriesCol = collection(db, "universalCategories");
      const categoriesSnapshot = await getDocs(categoriesCol);
      let genderArray = [];

      categoriesSnapshot.docs.forEach((doc) => {
        let GenderData = doc.data();
        genderArray.push(GenderData);
      });

      let maleCategories = genderArray[0];
      let femaleCategories = genderArray[1];

      if (gender === "male") {
        setPrimaryCategories(maleCategories);
      } else if (gender === "female") {
        setPrimaryCategories(femaleCategories);
      }
    } catch (error) {
      console.error("Error fetching brand display names:", error);
      toast.error("Error fetching brand display names", toastOptions);
    } finally {
      setLoading(false);
    }
  };

  // Handle category click
  const handleCategoryClick = (categoryKey, item) => {
    const select = {
      // primaryCategory: categoryKey,
      category: item.category || "",
      subCategory: item.subCategory || "",
      subSubCategory: item.subSubCategory,
      subSubCategoryDisplayName: item.subSubCategoryDisplayName,
    };

    const isAlreadyAdded = categories?.some(
      (existing) =>
        existing.category === select.category &&
        existing.subCategory === select.subCategory &&
        existing.subSubCategory === select.subSubCategory
    );

    if (isAlreadyAdded) {
      setCategories((prev) =>
        prev.filter(
          (existing) =>
            !(
              existing.category === select.category &&
              existing.subCategory === select.subCategory &&
              existing.subSubCategory === select.subSubCategory
            )
        )
      );
    } else {
      setCategories((prev) => [...(prev || []), select]);
    }
  };

  const toggleCategoryVisibility = (categoryKey) => {
    setVisibleCategories((prevState) => ({
      ...prevState,
      [categoryKey]: !prevState[categoryKey],
    }));
  };

  useEffect(() => {
    if (gender === "") return;
    const fetchData = async () => {
      await fetchCategories();
    };
    fetchData();
    // eslint-disable-next-line
  }, [gender]);

  // Save selected categories
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const userDocRef = doc(db, "users", user.uid);
      await updateDoc(userDocRef, {
        favCategories: categories,
      });
      console.log("User profile updated successfully");
      toast.success("Profile updated successfully", toastOptions);
    } catch (error) {
      console.error(error);
      toast.error("Error updating profile", toastOptions);
    }
  };

  // Fetch user profile
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        if (user && user.uid) {
          const userDocRef = doc(db, "users", user.uid);
          const userDocSnapshot = await getDoc(userDocRef);

          if (userDocSnapshot.exists()) {
            const userDataFromDb = userDocSnapshot.data();
            setCategories(userDataFromDb.favCategories || []);
            setGender(userDataFromDb.gender || "male");
          }
        }
      } catch (error) {
        console.error("Error fetching user data from database", error);
      }
    };

    fetchUserData();
  }, [user]);

  return (
    <div className="w-100">
      <div className="pb-0 p-3">
        <h5>Favorite Categories</h5>
      </div>
      <div className="pt-0 p-3">
        {loading ? (
          <LoadingSpinner />
        ) : (
          <form onSubmit={handleSubmit}>
            <div>
              {Object.keys(primaryCategories || {})?.map((categoryKey) => (
                <div
                  key={categoryKey}
                  className="mt-1 d-flex flex-column align-items-start"
                >
                  <li
                    className="fs-6 fw-bold my-2"
                    style={{ listStyleType: "none", cursor: "pointer" }}
                    onClick={() => toggleCategoryVisibility(categoryKey)}
                  >
                    {categoryKey}
                  </li>
                  {visibleCategories[categoryKey] && (
                    <ul className="list-inline mb-0 d-flex flex-wrap gap-1">
                      {primaryCategories[categoryKey].map((item, index) => (
                        <li
                          key={index}
                          onClick={() => handleCategoryClick(categoryKey, item)}
                        >
                          <div
                            className={`btn btn-outline-light brand-button btn-sm ${
                              categories?.some(
                                (element) =>
                                  // element.primaryCategory === categoryKey &&
                                  element.category === item.category &&
                                  element.subCategory === item.subCategory &&
                                  element.subSubCategory === item.subSubCategory
                              )
                                ? "bg-primary btn-primary text-light"
                                : ""
                            }`}
                          >
                            {item.subSubCategoryDisplayName}
                          </div>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
            <div className="text-end mt-3">
              <button
                type="submit"
                className="btn btn-sm btn-primary mb-0 rounded-2"
              >
                Save changes
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default CategorySelection;
